<template>
  <div>
    <div class="uk-text-center">
      <div class="fnt-med uk-margin-small-bottom">
        <span v-html="title"></span>
      </div>
      <div class="manager__avatar">
        <img
          :src="avatar"
          uk-img
          class="uk-border-circle"
        >
      </div>
      <div class="fnt-med uk-margin-small-top">{{ name }}</div>
      <div class="uk-flex-center uk-grid uk-grid-small uk-margin-small-top uk-margin-small-bottom">
        <span v-if="!statusPhone" class="fs20 fnt-med cl-dark-blue">{{ phone.value | phoneSecret(...phone.mask) }}</span>
        <a :href="`tel:+7${getPhoneNumber(phone.value)}`" v-else class="fs20 fnt-med cl-dark-blue">{{ phone.value | phoneType(...phone.mask) }}</a>
        <div class="fr uk-width-auto@s uk-width-1-1 cr-pointer" @click="statusPhone = true" v-if="!statusPhone">
          <span uk-icon="icon:unlock"></span> Показать номер
        </div>
      </div>
      <form @submit.prevent="send">
        <div class="uk-width-1-1 modal-input uk-grid uk-grid-small uk-flex-center uk-margin-remove">
          <div class="uk-width-1-1 uk-margin-bottom uk-padding-remove">
            <phone v-model="inputs.phone"/>
          </div>
          <div class="uk-width-auto uk-padding-remove">
            <button class="btn btn__tpl1 btn__bg-two uk-text-lowercase uk-width-1-1">{{ btn.name }}</button>
          </div>
        </div>
        <div class="uk-grid uk-grid-collapse uk-flex-center uk-margin-top social-msg">
          <div :class="{'uk-margin-small-right': (index + 1) != socials.length }" v-for="(social, index) in socials">
            <a :href="social.src" :target="social.target">
              <img :src="social.img" alt="">
            </a>
          </div>
        </div>
          <politica/>
      </form>
    </div>
  </div>

</template>

<script>
import form from '@/mixins/Form.js'
import input from '@/filters/Input.js'
import politica from '@/components/form/politica'
import phone from '@/components/form/input/phone'

export default {
  name: 'manager',
  mixins: [form, input],
  components: {
     phone, politica
  },
  props: {
    title: {
      type: String,
      default: 'Узнайте с чего начать строительство дома'
    },
    avatar: {
      type: String,
      default: '/img/spec.jpg'
    },
    name: {
      type: String,
      default: 'Владимир Олейников'
    },

    phone: {
      default() {
        return {
          value: this.$store.state.contacts.phone,
          mask: [4, 2, 2, 2]
        }
      }
    },

    form: {
      type: String,
      default: ''
    },
    staffId: {
      type: Number
    },
    managerId: {
      type: Number
    },
    sourceId: {
      type: Number
    },

    btn: {
      default() {
        return {
          name: `Жду звонка`
        }
      }
    },

    socials: {
      default() {
        return [
          {
            img: 'https://cdn.vevanta.com/sk/4.png',
            src: 'https://t.me/AntonovBro',
            target: '',
          },

          {
            img: 'https://cdn.vevanta.com/sk/whatsapp.png',
            src: 'https://wa.me/79323212510?text=Здравствуйте%2C+у+меня+есть+вопрос',
            target: '',
          },

          {
            img: 'https://cdn.vevanta.com/sk/viber.png',
            src: 'viber://chat?number=79323212510',
            target: '',
          },
        ]
      }
    },
  },
  data() {
    return {
      statusPhone: false,
    }
  },


  methods: {
    send() {
      this.formName =  this.form
      if (this.staffId !== undefined) {
        this.dataRequest.staffId = this.staffId
      }

      if (this.managerId !== undefined) {
        this.dataRequest.managerId = this.managerId
      }

      if (this.sourceId !== undefined) {
        this.dataRequest.sourceId = this.sourceId
      }

      this.sendForm()
    },
  },

}
</script>

<style scoped>
.manager__avatar img {
  max-width: 180px;
}

.social-msg img {
  max-width: 28px
}
</style>
